export const SelectChargeTypeOpt = [
  { id: 2, name: 'Per Unit', translationKey: 'gsPerUnit' },
  { id: 1, name: 'Per Kg', translationKey: 'perKgShort' },
]
export const selectChargeOpt = [
  { id: 1, name: 'Pickup Cartage', translationKey: 'pickupCartage' },
  { id: 2, name: 'Drop Off Cartage', translationKey: 'dropOffCartage' },
]
export const headers = [
  { header: 'SN', translationKey: 'gsSN', field: 'SN', width: '20px', align: 'left', showfilter: false },
  { header: 'Company Name', translationKey: 'companyName', field: 'CompanyName', width: '200px', showfilter: true },
  { header: 'Branch Name', translationKey: 'branchName', field: 'BranchName', width: '190px', showfilter: true },
  { header: 'City Name', translationKey: 'cityName', field: 'CityName', width: '107px', showfilter: true },
  { header: 'State Name', translationKey: 'stateName', field: 'StateName', width: '100px', showfilter: true },
  { header: 'Cartage Type', translationKey: 'cartageType', field: 'ChargeType', width: '90px', showfilter: true },
  { header: 'Range Min.', translationKey: 'gsRangeMin', field: 'RangeMin', width: '84px', align: 'right', showfilter: true },
  { header: 'Range Max.', translationKey: 'gsRangeMax', field: 'RangeMax', width: '106px', align: 'right', showfilter: true },
  { header: 'Cartage', translationKey: 'cartage', field: 'Rate', width: '84px', align: 'right', showfilter: true },
  { header: 'Modified By', translationKey: 'gsModBy', field: 'ModifiedByUser', width: '120px', showfilter: true },
  { header: 'Modified Date & Time', translationKey: 'gsModDt', field: 'ModifiedDateTime', width: '140px', showfilter: false },
  { header: 'Status', translationKey: 'gsStatus', field: 'Status', width: '60px', showfilter: false, align: 'center' },
]

export const cartageModalTableHeader = [
  { headerName: 'Range Min', translationKey: 'gsRangeMin2', headerSx: { minWidth: '25%', textAlign: 'right' } },
  { headerName: 'Range Max', translationKey: 'gsRangeMax2', headerSx: { minWidth: '25%', textAlign: 'right' } },
  { headerName: 'Rate', translationKey: 'rate', headerSx: { minWidth: '25%', textAlign: 'right' } },
  { headerName: 'Action', translationKey: 'gsAction', headerSx: { minWidth: '25%', textAlign: 'left' } },
]
export const cartageModalTableHeaderKM = [
  { headerName: 'From KG - To KG', translationKey: 'fromKgToKg', headerSx: { minWidth: '27%', textAlign: 'right' } },
  { headerName: 'From KM - To KM', translationKey: 'fromKmToKm', headerSx: { minWidth: '27%', textAlign: 'right' } },
  { headerName: 'Rate Per KG-KM', translationKey: 'ratePerKgKm', headerSx: { minWidth: '25%', textAlign: 'right' } },
  { headerName: 'Action', translationKey: 'gsAction', headerSx: { minWidth: '20%', textAlign: 'right' } },
]
